<h1 >Create league</h1>
<div >
  <mat-tab-group>
    <mat-tab label="Detail">
      <form [formGroup]="formData" (ngSubmit)="save()" class="league-detail">
        <mat-form-field>
          <mat-label>url</mat-label>
          <input type="text" matInput formControlName="url">
        </mat-form-field>
        <p class="hint">id, název, federaci, loga a seznam týmů doplňuje server z WBSC automaticky. Tady uprav barvy/loga týmů, skin a komponenty.</p>
        <mat-form-field>
          <mat-label>id</mat-label>
          <input type="text" matInput formControlName="id">
        </mat-form-field>
        <mat-form-field>
          <mat-label>name</mat-label>
          <input type="text" matInput formControlName="name">
        </mat-form-field>
        <mat-form-field>
          <mat-label>federation</mat-label>
          <input type="text" matInput formControlName="federation">
        </mat-form-field>
        <mat-form-field>
          <mat-label>skin</mat-label>
          <mat-select formControlName="skinId">
            <mat-option *ngFor="let skin of skins" [value]="skin.id">{{skin.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>smallLogoUrl</mat-label>
          <input type="text" matInput formControlName="smallLogoUrl">
          <button mat-flat-button type="button" (click)="select('smallLogoUrl')">Select</button>
        </mat-form-field>
        <mat-form-field>
          <mat-label>bigLogoUrl</mat-label>
          <input type="text" matInput formControlName="bigLogoUrl">
          <button mat-flat-button type="button" (click)="select('bigLogoUrl')">Select</button>
        </mat-form-field>
        <mat-form-field>
          <mat-label>backgroundColor</mat-label>
          <input type="text" matInput formControlName="backgroundColor">
          <ngx-colors
            class="prefix"
            matPrefix
            ngx-colors-trigger
            formControlName="backgroundColor"
            [hideColorPicker]="false"
            [hideTextInput]="false"
          ></ngx-colors>
        </mat-form-field>
        <mat-checkbox formControlName="poweredBy">Powered by</mat-checkbox>
        <mat-checkbox formControlName="licenced">Licenced</mat-checkbox>
        <mat-checkbox formControlName="archived">Archived</mat-checkbox>
      </form>
    </mat-tab>
    <mat-tab label="Teams">
      <form [formGroup]="teamsFormData" *ngIf="league?.teams && teamsFormData">
        <div [formGroupName]="'team'+i" *ngFor="let team of league?.teams; index as i">
          <mat-form-field>
            <mat-label>id</mat-label>
            <input type="text" matInput [formControlName]="'id'">
          </mat-form-field>
          <mat-form-field>
            <mat-label>shortName</mat-label>
            <input type="text" matInput [formControlName]="'shortName'">
          </mat-form-field>
          <mat-form-field>
            <mat-label>fullName</mat-label>
            <input type="text" matInput [formControlName]="'fullName'">
          </mat-form-field>
          <mat-form-field>
            <mat-label>primaryColor</mat-label>
            <input type="text" matInput [formControlName]="'primaryColor'">
            <ngx-colors
              class="prefix"
              matPrefix
              ngx-colors-trigger
              formControlName="primaryColor"
              [hideColorPicker]="false"
              [hideTextInput]="false"
            ></ngx-colors>
          </mat-form-field>
          <mat-form-field>
            <mat-label>secondaryColor</mat-label>
            <input type="text" matInput [formControlName]="'secondaryColor'">
            <ngx-colors
              class="prefix"
              matPrefix
              ngx-colors-trigger
              formControlName="secondaryColor"
              [hideColorPicker]="false"
              [hideTextInput]="false"
            ></ngx-colors>
          </mat-form-field>
          <mat-form-field>
            <mat-label>logoUrl</mat-label>
            <input type="text" matInput  [formControlName]="'logoUrl'">
          </mat-form-field>
          <mat-checkbox [formControlName]="'licenced'">Licenced</mat-checkbox>
          <button mat-stroked-button type="button" (click)="deleteTeam(team.id)">Delete</button>
        </div>
      </form>
      <button mat-stroked-button type="button" (click)="addTeam()">Add</button>
    </mat-tab>
    <mat-tab label="Partner Logos">
      <form [formGroup]="partnerLogosFormData" *ngIf="partnerLogosFormData">
        <div *ngFor="let logoUrl of partnerLogoUrls; index as i" class="partner-logo-item">
          <mat-form-field>
            <mat-label>Logo URL {{i+1}}</mat-label>
            <input type="text" matInput [formControlName]="'logo'+i">
            <button mat-flat-button type="button" (click)="selectPartnerLogo(i)">Select</button>
          </mat-form-field>
          <button mat-stroked-button type="button" (click)="removePartnerLogo(i)">Remove</button>
        </div>
        <button mat-stroked-button type="button" (click)="addPartnerLogo()">Add Logo</button>
      </form>
    </mat-tab>
    <mat-tab label="Components">
      <form [formGroup]="componentsFormData" *ngIf="componentsFormData">
        <div *ngFor="let c of allComponents">
          <mat-checkbox [formControlName]="c">{{c}}</mat-checkbox>
        </div>
      </form>
    </mat-tab>
  </mat-tab-group>
</div>
<div>

  <button mat-flat-button routerLink="/admin">Cancel</button>

  <button mat-flat-button color="primary" (click)="save()">Save</button>
</div>
